module.exports = __webpack_public_path__ + "static/media/paradise_center.30c3d3ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/paradise_center.jpg
// module id = 599
// module chunks = 0